'use client';
import type {ComponentProps, FC} from 'react';

import {Paragraph} from '@/modules/foundation/components/typography/paragraph';
import {cn} from '@/modules/foundation/shared/tailwind';

import {Checkbox} from '../../../form/Checkbox';
import {FormattedItemPrice} from '../../../item/FormattedItemPrice';
import {ProductColorSelector} from '../../../product-color/ProductColorSelector';
import type {CabFloorMatEdgingOptionForSelector} from '../query';

type CabFloorMatEdgingColorSelectorProps = {
	legend?: string;
	namePrefix?: string;
	option: CabFloorMatEdgingOptionForSelector;
	defaultConfiguration: string | null;
} & ComponentProps<'div'>;

export const CabFloorMatEdgingColorSelector: FC<CabFloorMatEdgingColorSelectorProps> = ({
	option,
	namePrefix,
	legend,
	defaultConfiguration,
	className,
	...rest
}) => {
	return (
		<div
			className={cn(
				'flex flex-col items-stretch gap-2 rounded-sm border-2 border-neutral-600 bg-neutral-800/50 leading-0 font-semibold select-none',
				'min-h-12 px-3 text-base lg:min-h-14 lg:px-4 lg:text-lg',
				'has-[*>:checked]:border-primary has-[*>:checked]:outline-2 has-[*>:checked]:-outline-offset-4 has-[*>:checked]:outline-neutral-800',
				className,
			)}
			{...rest}
		>
			<Checkbox
				value="enabled"
				name={namePrefix}
				defaultChecked={!!defaultConfiguration}
				labelProps={{
					className: 'flex h-12 lg:h-14',
				}}
			>
				{legend}{' '}
				{option.item && (
					<>
						{' (+ '}
						<FormattedItemPrice items={[option.item]} />
						{')'}
					</>
				)}
			</Checkbox>
			{defaultConfiguration && (
				<div className="mt-2 flex flex-col gap-4 pb-4">
					<Paragraph className="mb-2">
						Matten leveres som standard med samme kantfarge som resten av matten. Her
						kan du velge en annen kantfarge hvis du ønsker det.
					</Paragraph>
					<ProductColorSelector
						namePrefix={`${namePrefix}.colorId`}
						colors={option.edgingColors ?? []}
						defaultConfiguration={defaultConfiguration}
						disableNoneSelection
					/>
				</div>
			)}
		</div>
	);
};
